import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { getKeywordOption } from "./utils/adrUtilsV3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ADR_EDIT } from "../../_constants/actionConstants";
import {
  convertFromRaw,
  convertToRaw,
  Editor,
  EditorState,
  RichUtils,
  ContentState,
} from "draft-js";
import adrActions from "../../_actions/adrActions";
import AdrGeneralCommentAttachmentsV3 from "./AdrGeneralCommentAttachmentsV3";

class AdrGeneralCommentRowV3 extends Component {
  state = {
    formData: {
      subject: "",
      narrative: "",
      selectedKeywords: [],
    },
    editorState: EditorState.createEmpty(),
    showGcaBlock: false,
    showModal_fileUpload: false,
  };

  componentDidMount() {
    const { comment, projKeywordList } = this.props;
    const formData = {
      subject: comment.subject,
      narrative: comment.narrative,
      selectedKeywords: (projKeywordList || [])
        .filter((kw) => comment.keywordIds.includes(kw.keywordId))
        .map((kw) => getKeywordOption(kw)),
    };
    const editorState = comment.narrativeDraftState
      ? EditorState.createWithContent(
          convertFromRaw(JSON.parse(comment.narrativeDraftState))
        )
      : comment.narrative
      ? EditorState.createWithContent(ContentState.createFromText(comment.narrative))
      : EditorState.createEmpty();

    this.setState({ formData, editorState });
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const { comment: currComment, projKeywordList } = this.props;
  //   if (prevProps.generalComments) {
  //     const prevComment = prevProps.generalComments;
  //     let formData = {};

  //     if (prevComment.subject !== currComment.subject)
  //       formData.subject = currComment.subject;
  //     if (prevComment.narrative !== currComment.narrative)
  //       formData.narrative = currComment.narrative;
  //     if (prevComment.narrativeDraftState !== currComment.narrativeDraftState)
  //       formData.narrativeDraftState = currComment.narrativeDraftState;

  //     formData.selectedKeywords = (projKeywordList || [])
  //       .filter((kw) => currComment.keywordIds.includes(kw.keywordId))
  //       .map((kw) => getKeywordOption(kw));

  //     this.setState({ formData: { ...this.state.formData, ...formData } });
  //   }
  // }

  handleChange = (e) =>
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      this.props.markAdrDirty
    );

  handleChange_draft = (editorState) =>
    this.setState({ editorState }, this.props.markAdrDirty);

  handleBlur_draft = () => {
    const { dispatch, tabId, comment } = this.props;
    const { editorState } = this.state;

    const narrative = editorState.getCurrentContent().getPlainText();
    const narrativeDraftState = JSON.stringify(
      convertToRaw(editorState.getCurrentContent())
    );

    dispatch({
      type: ADR_EDIT.GENERAL_COMMENTS.UPDATE,
      tabId,
      clientId: comment.clientId,
      gcFields: { narrative, narrativeDraftState },
    });
  };

  handleKeyCommand = (command) => {
    const { editorState } = this.state;
    const newEditorState = RichUtils.handleKeyCommand(editorState, command);
    if (newEditorState) {
      this.handleChange_draft(newEditorState);
      return "handled";
    }
    return "not-handled";
  };

  handleClick_inlineStyle = (inlineStyle) => (e) => {
    e.preventDefault();
    this.setState({
      editorState: RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle),
    });
  };

  handleClick_blockStyle = (blockType) => (e) => {
    e.preventDefault();
    this.setState({
      editorState: RichUtils.toggleBlockType(this.state.editorState, blockType),
    });
  };

  handleBlur = (e) => {
    const { dispatch, tabId, comment } = this.props;
    dispatch({
      type: ADR_EDIT.GENERAL_COMMENTS.UPDATE,
      tabId,
      clientId: comment.clientId,
      gcFields: { [e.target.name]: e.target.value },
    });
  };

  handleChange_keywords = (selectedKeywords) => {
    const { dispatch, tabId, comment, markAdrDirty } = this.props;
    this.setState(
      { formData: { ...this.state.formData, selectedKeywords: selectedKeywords || [] } },
      markAdrDirty
    );
    const keywordIds = (selectedKeywords || []).map((kwo) => kwo.value);
    dispatch({
      type: ADR_EDIT.GENERAL_COMMENTS.KEYWORDS.UPDATE,
      tabId,
      clientId: comment.clientId,
      keywordIds,
    });
  };

  handleClick_delete = (e) => {
    e.preventDefault();
    const { dispatch, tabId, comment, markAdrDirty } = this.props;
    let filePathsToDelete = [];

    comment.commentAttachments.forEach(
      (ca) =>
        (filePathsToDelete = [
          ...filePathsToDelete,
          ca.filePath,
          ca.imageThumbnailFilePath,
        ])
    );

    dispatch(adrActions.deleteAttachments(filePathsToDelete));
    dispatch({
      type: ADR_EDIT.GENERAL_COMMENTS.DELETE,
      tabId,
      clientId: comment.clientId,
    });
    markAdrDirty();
  };

  toggleModal_fileUpload = () =>
    this.setState({ showModal_fileUpload: !this.state.showModal_fileUpload });

  toggleGcaBlock = () => this.setState({ showGcaBlock: !this.state.showGcaBlock });

  // Provided as custom callback to fileUploadModal
  openLaBlock = () => !this.state.showGcaBlock && this.setState({ showGcaBlock: true });

  renderEditor = (idSuffix) => {
    const { editorState } = this.state;
    const { status } = this.props;

    const currStyles = Array.from(editorState.getCurrentInlineStyle());
    const currSelection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(currSelection.getStartKey())
      .getType();

    return (
      <div
        className={`d-flex flex-column w-100 px-0 locwp-row-work-desc ${
          status.isReadOnly && "editor-disabled"
        }`}
      >
        <div className="d-flex flex-row adr-editor-toolbar">
          <button
            type="button"
            id={`genCommNarr_bold_${idSuffix}`}
            name="bold"
            className={`mr-1 btn ${
              currStyles.includes("BOLD") ? "btn-secondary" : "btn-light"
            }`}
            onMouseDown={this.handleClick_inlineStyle("BOLD")}
            onTouchEnd={this.handleClick_inlineStyle("BOLD")}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="bold" className="fa-fw" />
          </button>
          <button
            type="button"
            id={`genCommNarr_italic_${idSuffix}`}
            name="italic"
            className={`mr-1 btn ${
              currStyles.includes("ITALIC") ? "btn-secondary" : "btn-light"
            }`}
            onMouseDown={this.handleClick_inlineStyle("ITALIC")}
            onTouchEnd={this.handleClick_inlineStyle("ITALIC")}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="italic" className="fa-fw" />
          </button>
          <button
            type="button"
            id={`genCommNarr_underline_${idSuffix}`}
            name="underline"
            className={`btn ${
              currStyles.includes("UNDERLINE") ? "btn-secondary" : "btn-light"
            }`}
            onMouseDown={this.handleClick_inlineStyle("UNDERLINE")}
            onTouchEnd={this.handleClick_inlineStyle("UNDERLINE")}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="underline" className="fa-fw" />
          </button>
          <span className="mx-1 text-muted">|</span>
          <button
            type="button"
            id={`genCommNarr_ul_${idSuffix}`}
            name="unordered-list-item"
            className={`mr-1 btn ${
              blockType === "unordered-list-item" ? "btn-secondary" : "btn-light"
            }`}
            onMouseDown={this.handleClick_blockStyle("unordered-list-item")}
            onTouchEnd={this.handleClick_blockStyle("unordered-list-item")}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="list-ul" className="fa-fw" />
          </button>
          <button
            type="button"
            id={`genCommNarr_ol_${idSuffix}`}
            name="ordered-list-item"
            className={`btn ${
              blockType === "ordered-list-item" ? "btn-secondary" : "btn-light"
            }`}
            onMouseDown={this.handleClick_blockStyle("ordered-list-item")}
            onTouchEnd={this.handleClick_blockStyle("ordered-list-item")}
            disabled={status.isReadOnly}
          >
            <FontAwesomeIcon icon="list-ol" className="fa-fw" />
          </button>
        </div>
        <div>
          <Editor
            name="narrative"
            id={`genCommNarr_narr_${idSuffix}`}
            editorState={editorState}
            onChange={this.handleChange_draft}
            onBlur={this.handleBlur_draft}
            handleKeyCommand={this.handleKeyCommand}
            readOnly={status.isReadOnly}
            spellCheck={true}
            autoCorrect="off"
          />
        </div>
      </div>
    );
  };

  render() {
    const { comment, projKeywordList, status, fileUploadModal, tabId, projectId } =
      this.props;
    const { formData, showModal_fileUpload, showGcaBlock } = this.state;

    return (
      <React.Fragment>
        <div
          className="mt-2 general-comment-row"
          id={`generalCommentRowId_${comment.clientId}`}
        >
          <div key="gcHrBody" className="form-row">
            <div className="col-10">
              <div className="form-row form-group mb-2">
                <label className="col-sm-2 col-form-label">
                  <strong>Subject:</strong>
                </label>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    name={"subject"}
                    id={`generalComments_subject_${comment.clientId}`}
                    value={formData.subject}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    disabled={status.isReadOnly}
                  />
                </div>
              </div>
              <div className="form-row form-group mb-1">
                <label className="col-sm-2 col-form-label">
                  Keywords:
                </label>
                <div className="col-sm-10">
                  <Select
                    name={"keywordIds"}
                    id={`generalComments_kw_${comment.clientId}`}
                    value={formData.selectedKeywords || []}
                    onChange={this.handleChange_keywords}
                    options={(projKeywordList || []).map((kw) => getKeywordOption(kw))}
                    placeholder="Select or Type Keywords"
                    isMulti
                    isClearable
                    isSearchable
                    isDisabled={status.isReadOnly}
                  />
                </div>
              </div>
              <div className="form-row form-group mb-1 mt-2">
                <label className="col-sm-2">
                  Comments:
                </label>
                <div className="col-sm-10">{this.renderEditor(comment.clientId)}</div>
              </div>
              {comment &&
                comment.commentAttachments &&
                comment.commentAttachments.length > 0 && (
                  <AdrGeneralCommentAttachmentsV3
                    comment={comment}
                    showGcaBlock={showGcaBlock}
                    toggleGcaBlock={this.toggleGcaBlock}
                    toggleModal_fileUpload={this.toggleModal_fileUpload}
                    tabId={tabId}
                    projectId={projectId}
                  />
                )}
            </div>
            <div className="col-2 general-coment-button-group">
              <div className="form-group mb-2">
                <button
                  type="button"
                  id={`gcAttachFilesButton_${comment.clientId}`}
                  name="gcAttachFilesButton"
                  className="btn btn-secondary mr-2"
                  onClick={this.toggleModal_fileUpload}
                  disabled={status.isReadOnly}
                >
                  <FontAwesomeIcon icon="paperclip" className="mr-2" />
                  <span className="badge badge-pill badge-light my-auto">
                    {comment.commentAttachments.filter((ca) => !ca.isDeleted).length}
                  </span>
                </button>
              </div>
              <div className="form-group mt-0 general-comment-copy-delete">
                <button
                  type="button"
                  className="btn btn-danger delete"
                  id={`generalCommentsDeleteId_${comment.clientId}`}
                  onClick={this.handleClick_delete}
                  disabled={status.isReadOnly}
                >
                  <FontAwesomeIcon icon="times" className="fa-fw" />
                </button>
              </div>
            </div>
          </div>
          <hr key="gcHrBottom" className="mb-2 mt-2" />
        </div>
        {showModal_fileUpload &&
          fileUploadModal({
            wpTabId: null,
            locationId: null,
            locWpClientId: null,
            gcClientId: comment.clientId,
            targetCategory: 46,
            showModal_fileUpload,
            toggleModal_fileUpload: this.toggleModal_fileUpload,
          })}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projKeywordList: state.keywords.projKeywordLists[ownProps.projectId] || null,
});

export default connect(mapStateToProps)(AdrGeneralCommentRowV3);
